import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { RsaPreviewData } from '../../../../../../../models/google-template/preview-interfaces/rsa-preview-data.interface';

/**
 * Presentational desktop SERP mock for the Google RSA Search preview. Renders
 * the flat {@link RsaPreviewData} DTO only — all block reading lives in the
 * shell ({@link GoogleRsaPreviewComponent}).
 */
@Component({
    selector: 'app-rsa-google-desktop-01',
    imports: [CommonModule],
    templateUrl: './rsa-google-desktop-01.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './rsa-google-desktop-01.component.scss'
})
export class RsaGoogleDesktop01PreviewComponent {
  @Input() data!: RsaPreviewData;
}
